module.exports = __webpack_public_path__ + "img/WeChat_login.35422561.svg";